import React from 'react'
import { css, useTheme } from '@emotion/react'
import { Box, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import { HiExclamationCircle } from 'react-icons/hi'

import BasicDialog from '../../../../components/elements/BasicDialog'
import Button from '../../../../components/elements/Button'

export default function FailureDialog({ isOpen, onClose, onRestart, score }) {
  const theme = useTheme()
  const t = useTranslations()
  
  const styles = {
    content: css`
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 24px;
      padding: 16px;
      min-width: 320px;
    `,
    iconContainer: css`
      display: flex;
      justify-content: center;
      margin-bottom: 8px;
    `,
    failureIcon: css`
      font-size: 64px;
      color: ${theme.palette.error.main};
    `,
    title: css`
      font-size: 1.5rem;
      font-weight: 600;
      color: ${theme.palette.error.main};
      text-align: center;
    `,
    message: css`
      text-align: center;
      margin-bottom: 16px;
    `,
    statsContainer: css`
      display: flex;
      flex-direction: column;
      gap: 8px;
      background-color: ${theme.palette.surface.lighter};
      padding: 16px;
      border-radius: 8px;
      width: 100%;
    `,
    statRow: css`
      display: flex;
      justify-content: space-between;
      font-size: 1.1rem;
    `,
    statValue: css`
      font-weight: 600;
    `,
    tips: css`
      background-color: ${theme.palette.surface.lighter};
      padding: 16px;
      border-radius: 8px;
      width: 100%;
    `,
    tipTitle: css`
      font-weight: 600;
      margin-bottom: 8px;
    `,
    tipList: css`
      margin: 0;
      padding-left: 20px;
      
      li {
        margin-bottom: 4px;
      }
    `
  }
  
  const dialogActions = (
    <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
      <Button onClick={onClose}>{t('kana-connect.close-action')}</Button>
      <Button 
        onClick={onRestart}
        color="primary"
      >
        {t('kana-connect.try-again')}
      </Button>
    </Box>
  )

  return (
    <BasicDialog
      title={t('kana-connect.timeout-title')}
      open={isOpen}
      onClose={onClose}
      actions={dialogActions}
    >
      <div css={styles.content}>
        <div css={styles.iconContainer}>
          <HiExclamationCircle css={styles.failureIcon} />
        </div>
        
        <Typography css={styles.title}>{t('kana-connect.challenge-failed-title')}</Typography>
        
        <Typography css={styles.message}>
          {t('kana-connect.failure-message')}
        </Typography>
        
        <div css={styles.statsContainer}>
          <div css={styles.statRow}>
            <span>{t('kana-connect.final-score-value')}</span>
            <span css={styles.statValue}>{score} 分</span>
          </div>
                  </div>
                  
                  <div css={styles.tips}>
          <div css={styles.tipTitle}>{t('kana-connect.tips-title')}</div>
          <ul css={styles.tipList}>
            <li>{t('kana-connect.tip-1')}</li>
            <li>{t('kana-connect.tip-2')}</li>
            <li>{t('kana-connect.tip-3')}</li>
            <li>{t('kana-connect.tip-4')}</li>
          </ul>
        </div>
      </div>
    </BasicDialog>
  )
}
